import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Planzone,
  TimeRecordsListingConfiguration,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configuration: TimeRecordsListingConfiguration;
  retrieveTimeRecordsListingConfiguration(
    req: Boundaries["retrieveTimeRecordsListingConfiguration"]["request"],
  ): void;
}

function useRetrieveTimeRecordsListingConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveTimeRecordsListingConfigurationRequestPending(
        planzone,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveTimeRecordsListingConfigurationRequestSuccess(
        planzone,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveTimeRecordsListingConfigurationRequestFailure(
        planzone,
      ),
    ),
    configuration: useSelector(() =>
      selector.getTimeRecordsListingConfiguration(planzone),
    ),
    retrieveTimeRecordsListingConfiguration:
      core.retrieveTimeRecordsListingConfiguration,
  };
}

export { useRetrieveTimeRecordsListingConfiguration };
